import { mergeAttributes } from '@tiptap/core'
import TiptapHorizontalRule from '@tiptap/extension-horizontal-rule'

const HorizontalRule = TiptapHorizontalRule.extend({
  renderHTML() {
    return ['div', mergeAttributes(this.options.HTMLAttributes, { 'data-type': this.name, class: 'horizontalRule' }), ['hr']]
  },
})

export default HorizontalRule;
